import { render, staticRenderFns } from "./ClassRoom.vue?vue&type=template&id=fcebe166&scoped=true&"
import script from "./ClassRoom.vue?vue&type=script&lang=js&"
export * from "./ClassRoom.vue?vue&type=script&lang=js&"
import style0 from "./ClassRoom.vue?vue&type=style&index=0&id=fcebe166&scoped=true&lang=css&"
import style1 from "./ClassRoom.vue?vue&type=style&index=1&id=fcebe166&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcebe166",
  null
  
)

export default component.exports